import path from 'node:path'

import {type CliConfig, getSanityEnvVar, type Output} from '@sanity/cli-core'
import {spinner} from '@sanity/cli-core/ux'

import {type DevServerOptions} from '../../server/devServer.js'
import {getSharedServerConfig} from '../../util/getSharedServerConfig.js'
import {type DevFlags} from './types.js'

export function getDevServerConfig({
  cliConfig,
  flags,
  output,
  workDir,
}: {
  cliConfig?: CliConfig
  flags: DevFlags
  output: Output
  workDir: string
}): Omit<DevServerOptions, 'spinner'> {
  const configSpinner = spinner('Checking configuration files...')

  const baseConfig = getSharedServerConfig({
    cliConfig,
    flags: {
      host: flags.host,
      port: flags.port,
    },
    workDir,
  })

  configSpinner.succeed()

  const isApp = cliConfig && 'app' in cliConfig
  const env = process.env
  const reactStrictMode = env.SANITY_STUDIO_REACT_STRICT_MODE
    ? env.SANITY_STUDIO_REACT_STRICT_MODE === 'true'
    : Boolean(cliConfig?.reactStrictMode)

  const envBasePath = getSanityEnvVar('BASEPATH', isApp ?? false)
  if (envBasePath && cliConfig?.project?.basePath) {
    output.warn(
      `Overriding configured base path (${cliConfig.project.basePath}) with value from environment variable (${envBasePath})`,
    )
  }

  return {
    ...baseConfig,
    reactCompiler: cliConfig && 'reactCompiler' in cliConfig ? cliConfig.reactCompiler : undefined,
    reactStrictMode,
    staticPath: path.join(workDir, 'static'),
    typegen: cliConfig?.typegen,
  }
}
